import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.jsx';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';

/* dev
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fsale%2Fcustomer%2Forder%2Flist&response_type=code&scope=snsapi_base&state=123#wechat_redirect
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fpurchase%2Forder%2Flist&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/

function OrderChangeList(props) {
  const Config = {
    sale: {
      title: '客户变更列表',
      apiPath: '/customerChange/list',
      countApi: '/customerChange/count',
      countTransform: data => {
        //分类统计 [2交期差异待确认，1待答交, 3退回]
        let { 0: a } = data;
        setCount([undefined, a]);
      },
      orderProperty: 'poOrder.erpPurchaseDate',
      arrEnumField: [
        {
          mainKey: 'B02_co_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      companyNameLabel: '客户名称',
      companyCodeLabel: '客户编码',
      companyNameKey: 'innerCustomerName',
      companyCodeKey: 'innerCustomerCode',
      detailLink: '/mp/sale/customer/change/detail',
      searchBarPlaceholder: '客户名称/编码、订单编号、商品名称/编码/规格',
      tabs: ['全部', '待确认'],
      tabConfig: [
        [], //全部
        [0] //待确认变更单
      ]
    },
    purchase: {
      title: '采购变更列表',
      apiPath: '/change/list',
      countApi: '/change/count',
      countTransform: data => {
        //分类统计 [0:待供应商确认，4:供应商差异待审核]
        let { 0: a, 4: b } = data;
        setCount([a, b, undefined]);
      },
      orderProperty: 'poOrder.erpPurchaseDate',
      //枚举列表
      arrEnumField: [
        {
          mainKey: 'B02_co_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      companyNameLabel: '供应商名称',
      companyCodeLabel: '供应商编码',
      companyNameKey: 'innerVendorName',
      companyCodeKey: 'innerVendorCode',
      detailLink: '/mp/purchase/change/detail',
      searchBarPlaceholder: '供应商编码/名称、来源单据、物料编码/名称/规格',
      tabs: ['待供应商确认', '差异待审核', '全部'],
      tabConfig: [
        [], //待供应商确认
        [4], //供应商差异待审核
        [] //全部
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  //扩展搜索参数
  self.beforeSearch = async function () {
    let typeList = ['1', '', '0'];
    self.searchQueries.changeOrderType = typeList[currentTab];
    self.searchQueries.status = config.tabConfig[currentTab];
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="list-total">{total}</div>
            {/* 列表项 */}
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.pocXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.poErpNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass(
                                'B02_co_Status',
                                item.status
                              )
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        <li>
                          <label>{config.companyNameLabel}</label>
                          <div>{item[config.companyNameKey]}</div>
                        </li>
                        <li>
                          <label>{config.companyCodeLabel}</label>
                          <div>{item[config.companyCodeKey]}</div>
                        </li>
                        <li>
                          <label>变更序号</label>
                          <div>{item.changeSeq}</div>
                        </li>
                        <li>
                          <label>采购日期</label>
                          <div>{formatDate(item.erpPurchaseDate)}</div>
                        </li>
                        <li>
                          <label>变更日期</label>
                          <div>{formatDate(item.erpChangeDate)}</div>
                        </li>
                        <li>
                          <label>订单金额</label>
                          <div>
                            {item.changedIsContainTax
                              ? formatNumber(
                                  item.changedProductTaxTotal,
                                  item.Amount_Decimal_Place
                                )
                              : formatNumber(
                                  item.changedProductTotal,
                                  item.Amount_Decimal_Place
                                )}
                          </div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

OrderChangeList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(OrderChangeList);
